import { registerPlugin } from '@capacitor/core'

import type { HealthConnectPlugin } from './HealthConnectDefinitions'

const HealthConnect = registerPlugin<HealthConnectPlugin>('HealthConnect')

export { HealthConnect }
